import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */"@/pages/Dashboard.vue");
const Login = () => import(/* webpackChunkName: "dashboard" */"@/pages/Login.vue");
const Clocks = () => import(/* webpackChunkName: "common" */ "@/pages/Clocks.vue");
const Profile = () => import(/* webpackChunkName: "common" */ "@/pages/Profile.vue");
const Projects = () => import(/* webpackChunkName: "common" */ "@/pages/Projects.vue");
const EmployeesSettings = () => import(/* webpackChunkName: "common" */ "@/pages/EmployeesSettings.vue");
const EmployeesClocks = () => import(/* webpackChunkName: "common" */ "@/pages/EmployeesClocks.vue");
const ProjectsSettings = () => import(/* webpackChunkName: "common" */ "@/pages/Projects/ProjectsSettings.vue");
const ProjectsDocuments = () => import(/* webpackChunkName: "common" */ "@/pages/Projects/ProjectsDocuments.vue");
const ProjectsReports = () => import(/* webpackChunkName: "common" */ "@/pages/Projects/ProjectsReports.vue");
const EmployeesReports = () => import(/* webpackChunkName: "common" */ "@/pages/Projects/EmployeesReports.vue");
const Inventorization = () => import(/* webpackChunkName: "common" */ "@/pages/Projects/Inventorization.vue");
const IncomesExpenses = () => import(/* webpackChunkName: "common" */ "@/pages/IncomesExpenses.vue");
const IncomesExpensesSettings = () => import(/* webpackChunkName: "common" */ "@/pages/IncomesExpensesSettings.vue");
const Compensation = () => import(/* webpackChunkName: "common" */ "@/pages/Compensation.vue");
const SafetyDocs = () => import(/* webpackChunkName: "common" */"@/pages/SafetyDocs.vue");
const Tickets = () => import(/* webpackChunkName: "common" */"@/pages/Tickets.vue");
const TicketDetails = () => import(/* webpackChunkName: "common" */"@/pages/Tickets/TicketDetails.vue");
const Icons = () => import(/* webpackChunkName: "common" */ "@/pages/Icons.vue");
const News = () => import(/* webpackChunkName: "common" */ "@/pages/News.vue");

import { getCookie } from "../plugins/axios";

function guard(to, from, next){
  if (getCookie('Authentication') !== 'Pass' && to.name !== "login"){
    next('/login');
  }
  else{
    next();
  }
}

function check(to, from, next){
  if(parseInt(getCookie('Type-id')) > 4){
    next('/page-not-found');
  }
  else{
    next();
  }

}

const routes = [
  {
    path: "/",
    beforeEnter: guard,
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard
      },
      {
        path: "clocks",
        name: "clocks",
        component: Clocks
      },
      {
        path: "profile",
        name: "profile",
        component: Profile
      },
      {
        path: "news",
        name: "news",
        component: News
      },
      {
        beforeEnter: check,
        path: "employees-settings",
        name: "employees settings",
        component: EmployeesSettings
      },
      {
        beforeEnter: check,
        path: "employees-clocks",
        name: "employees clocks",
        component: EmployeesClocks
      },
      {
        beforeEnter: check,
        path: "projects-settings",
        name: "projects settings",
        component: ProjectsSettings
      },
      {
        beforeEnter: check,
        path: "projects-documents",
        name: "projects documents",
        component: ProjectsDocuments
      },
      {
        beforeEnter: check,
        path: "projects-reports",
        name: "projects reports",
        component: ProjectsReports
      },
      {
        beforeEnter: check,
        path: "employees-reports",
        name: "employees reports",
        component: EmployeesReports
      },
      {
        beforeEnter: check,
        path: "projects",
        name: "projects",
        component: Projects,
      },
      {
        beforeEnter: check,
        path: "projects-incomes-expenses",
        name: "incomes and expenses",
        component: IncomesExpenses
      },
      {
        beforeEnter: check,
        path: "inventory",
        name: "inventory",
        component: Inventorization
      },
      {
        beforeEnter: check,
        path: "incomes-expenses-settings",
        name: "column settings",
        component: IncomesExpensesSettings
      },
      {
        beforeEnter: check,
        path: "compensation",
        name: "compensation",
        component: Compensation
      },
      {
        beforeEnter: check,
        path: "safety-documents",
        name: "safety documents",
        component: SafetyDocs
      },
      {
        path: "tickets",
        name: "tickets",
        component: Tickets
      },
      {
        path: "ticket-details",
        name: "ticket's details",
        component: TicketDetails
      },
      {
        beforeEnter: check,
        path: "icons",
        name: "icons",
        component: Icons
      },
    ]
  },
  {
    path: "/login",
    beforeEnter: guard,
    name: "login",
    component: Login
  },
  { path: "*", component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/
export default routes;
